export enum LearningContentAttachmentType {
    other = 0,
    pdf = 1,
    audio = 2
}
